import React from "react";
import { AiOutlineDelete, AiOutlineEdit, AiOutlineSave } from "react-icons/ai";
import { toast } from "react-toastify";
const EditContent = ({
  formData,
  setIsEdit,
  content,
  setContent,
  isEdit,
  setFormData,
}) => {
  let contentId = content.id;
  const handleSaveEdit = (id) => {
    const index = formData.description.findIndex((data) => data.id === id);
    console.log(index);
    formData.description[index].header = content.header;
    formData.description[index].content = content.content;
    setIsEdit(false);
    setContent({ content: "", header: "" });

    // setFormData({content: })

    // console.log(formData.content);
    // setFormData({content: []});
  };

  return (
    <div className="edit-delete-container">
      {formData.description?.length > 0 &&
        formData.description?.map((data) => {
          const { id, header, content } = data;

          return (
            <div key={id} className="actions">
              <p style={{ width: "10ch" }}>{header}</p>

              <div className="action-btn">
                {/* contentId is the active content selected to edit
                checks the contentId if it is the active id */}
                {contentId !== id ? (
                  <AiOutlineEdit
                    className="editBtn"
                    onClick={() => {
                      setContent({
                        id: id,
                        content,
                        header,
                      });
                      setIsEdit(true);
                    }}
                  >
                    Edit
                  </AiOutlineEdit>
                ) : (
                  <AiOutlineSave
                    className="editBtn"
                    onClick={() => {
                      handleSaveEdit(id);
                    }}
                  >
                    Save
                  </AiOutlineSave>
                )}
                <AiOutlineDelete
                  className="deleteBtn"
                  onClick={() =>
                    isEdit
                      ? toast.error("Save your work first")
                      : setFormData({
                          ...formData,
                          description: formData.description.filter(
                            (data) => data.id !== id
                          ),
                        })
                  }
                >
                  Delete
                </AiOutlineDelete>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default EditContent;
